import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgMegaphone = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21 5.859v12.255a.74.74 0 0 1-.75.734.74.74 0 0 1-.75-.734v-.174l-5.553-1.48A3 3 0 0 1 11 18.848c-1.684 0-3-1.314-3-2.935 0-.348.034-.681.175-.993L4.5 13.938v.263a.74.74 0 0 1-.75.734.74.74 0 0 1-.75-.734V9.8c0-.407.336-.734.75-.734s.75.327.75.734v.263l15-4.003v-.173c0-.405.334-.734.75-.734s.75.329.75.734zM19.5 16.42V7.58l-15 4.001v.838zm-8.5.96c.775 0 1.41-.575 1.49-1.309l-2.856-.764a1.4 1.4 0 0 0-.134.605c0 .81.672 1.468 1.5 1.468"
    }));
export default SvgMegaphone;
